import styled from 'styled-components'

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  @media (min-width: 768px) {
    min-height: 300px;
  }
  @media (min-width: 992px) {
    min-height: 400px;
  }
  @media (min-width: 1200px) {
    min-height: 500px;
  }
`

export default SpinnerContainer
